"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/styles");
const react_1 = __importDefault(require("react"));
const react_flagkit_1 = __importDefault(require("react-flagkit"));
const react_i18next_1 = require("react-i18next");
const useStyles = (0, styles_1.makeStyles)(() => ({
    flag: {
        marginRight: "10px",
        cursor: "pointer",
    },
}));
function FlagButton({ country, lng }) {
    const classes = useStyles();
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_flagkit_1.default, { className: classes.flag, role: "button", title: t(`lang.${lng}`), country: country.toUpperCase(), tabIndex: 0, onClick: () => i18n.changeLanguage(lng), onKeyDown: (e) => e.key == "Enter" ? i18n.changeLanguage(lng) : null }));
}
exports.default = FlagButton;
